import { toast } from "react-toastify";

const showError = (message) => customToast(message, toast.error);
const showSuccess = (message) => customToast(message, toast.success);

const customToast = (message, toaster) => {
  if (message?.message) {
    toaster(message.message);
  }
  if (Array.isArray(message) && message.length > 0) {
    toaster(message[0]);
  }
  if (message) {
    toaster(message);
  }
};

export const ToastifyService = {
  showError,
  showSuccess,
};
